define('models/CountryModel',['underscore','ObjectModel','LocalStorage'],function (_,ObjectModel,LocalStorage) {
    //
    // Model Country
    //
    var CountryModelPrototype = {
        
        name:'CountryModel',
        idAttribute:'id_country',
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },

        getName:function(){
            return this.get('name');
        }
    };

    var CountryModel = ObjectModel.extend(LocalStorage).extend(CountryModelPrototype);
    
    return CountryModel;
});
